module.exports = __webpack_public_path__ + "img/Enshebei.a83a9688.png";